import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

// Payment status styling
export const PaymentStatusCell = styled.div`
  svg {
    margin-right: 6px;
  }
`;

export const SlotStatusCellIsPaid = styled.div`
  svg {
    fill: ${defaultTheme.COLORS.SUCCESS};
  }
`;

export const SlotStatusCellIsNotPaid = styled.div`
  svg {
    fill: ${defaultTheme.COLORS.SECONDARY};
  }
`;

export const SlotStatusCellIsCanceled = styled.div`
  svg {
    fill: ${defaultTheme.COLORS.ERROR};
  }
`;

export const SlotStatusCellIsNoShow = styled.div`
  svg {
    fill: ${defaultTheme.COLORS.ERROR};
  }
`;

export const SlotStatusCellIsOrganizerNoShow = styled.div`
  svg {
    fill: ${defaultTheme.COLORS.WARNING};
  }
`;

export const SlotStatusCellIsNoShowAll = styled.div`
  svg {
    fill: ${defaultTheme.COLORS.ERROR};
  }
`;

export const AlertDialog = styled.div``;

export const AlertDialogInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px;
  width: auto;
  max-width: 800px;
  flex-direction: column;
  height: 200px;
  border-radius: 0px;

  p {
    font-size: ${defaultTheme.FONT.SIZE.EXTRA_LARGE};
  }
`;

export const CancelButton = styled.button`
  color: #f9f9f9;
  margin-right: 10px;

  &:hover {
    background: none;
  }
`;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  color: white;
`;
